<template>
  <ul class="history_list">
    <li class="list_item" v-for="item of chatList">
      <button
        class="item"
        :class="{
          selected: selected && selected.id === item.id,
        }"
        @click="handleItemClick(item)"
      >
        <div class="user_info">
          <div class="user_photo">
            <img
              v-if="item.user.userImg"
              :src="item.user.userImg"
              :alt="item.user.name ? item.user.name : `Anonymous`"
            />

            <svg v-if="!item.user.userImg" class="item_svg">
              <use
                xlink:href="../../assets/icons/no_user_photo.svg#no_user_photo"
              />
            </svg>
          </div>

          <p class="title">
            {{
              item.user.name ||
              item.user.email ||
              item.user.phone ||
              `Id #${item.id}`
            }}
          </p>
        </div>
        <div class="user_data">
          <p class="time">{{ getTimeFromLastUpdate(item.finishedAt) }}</p>

          <svg v-if="item.favorite">
            <use xlink:href="../../assets/icons/star.svg#star" />
          </svg>
        </div>
      </button>
    </li>
  </ul>
</template>

<script>
import moment from "moment";

export default {
  props: {
    chatList: {
      type: Array,
      required: true,
    },
    selected: {
      type: Object | null,
    },
  },
  methods: {
    getTimeFromLastUpdate(date) {
      const time = moment(new Date(date)).fromNow();

      const returnTime = (timeString) => {
        if (timeString === "a few seconds ago") {
          timeString = "new";
        }

        if (timeString.includes("minute")) {
          timeString = timeString.replace("minute", "min");
        }

        if (timeString.includes("minutes")) {
          timeString = timeString.replace("minutes", "mins");
        }

        return timeString;
      };

      return returnTime(time);
    },

    handleItemClick(item) {
      this.$emit("chatItemClick", item);
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.history_list {
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.list_item {
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  overflow: hidden;
  margin: 0;
  display: flex;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #d1d1d6;
  background: #fff;
  width: 100%;
  transition: all ease-in-out 300ms;

  &:hover {
    background: #ebf0ff;
  }
}

.selected {
  background: #ebf0ff;
  border: 1px solid #3056d3;
}

.user_info {
  display: flex;
  gap: 8px;
  flex-grow: 1;
  max-width: 70%;

  @media screen and (max-width: 940px) {
    flex-direction: column;
  }
}

.user_photo {
  max-width: 54px;
  min-width: 54px;
  height: 54px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #e0e0e0;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 36px;
    height: 36px;
    fill: #637381;

    @media screen and (max-width: 940px) {
      width: 23px;
      height: 23px;
    }
  }

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media screen and (max-width: 940px) {
    max-width: 35px;
    min-width: 35px;
    height: 35px;
  }
}

.user_data {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  height: 54px;

  & > svg {
    fill: #3056d3;
    width: 24px;
    height: 24px;
  }
}

.title {
  padding: 0;
  margin: 0;
  color: #333;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;

  @media screen and (max-width: 940px) {
    font-size: 15px;
  }
}

.time {
  margin: 0 0 auto 0;
  padding: 0;
  color: #bdbdbd;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
}
</style>
